import React from 'react';
import Modal from 'components/UI/DialogModal';
import { CircularProgress, Grid, Typography } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { useTranslation } from 'react-i18next';


interface Props {
  open: boolean;
  loading: boolean;
  onClose: () => void;
  onSubmit: () => void;
}




const RejectEnrollment: React.FC<Props> = ({ open, loading, onClose, onSubmit }) => {
  const {t} = useTranslation()
return (<>
    <Modal
      open={open}
      onClose={onClose}
      title={t('T_reject_workshop')}  
      maxWidth="lg"
      children={<Grid container p={2}>
        <Typography variant="h6">{t('T_reject_workshop_confirm')}  </Typography>
      </Grid>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="outlined"
            sx={{ color: 'warning.main', borderColor: 'warning.main' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            color="error"
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t('T_reject')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default RejectEnrollment;
